import { CheckHandwrite } from '@pretto/picto'

import { PropTypes } from 'prop-types'
import { memo } from 'react'

import * as S from './styles'

export const Ticks = memo(({ ticks = [], ...props }) => (
  <S.Ticks {...props}>
    {ticks.map((tick, i) => (
      <S.Tick key={i}>
        <CheckHandwrite />
        {tick}
      </S.Tick>
    ))}
  </S.Ticks>
))

Ticks.propTypes = {
  ticks: PropTypes.arrayOf(PropTypes.string).isRequired,
}

Ticks.displayName = 'Ticks'
